<template>
	<div class="newsrotate">
		<div class="rotatecon">
			<el-carousel loop indicator-position="none" arrow="never"
			 height="4.4rem" ref="img" @change="changetab">
				<el-carousel-item v-for="(item,i) in list" :key="i">				
					<el-image fit='cover' :src="$fileAccessHttpUrl(item.fileId_dictText)" alt=""
					@click="tonav(item.link)"></el-image>			
				</el-carousel-item>
			</el-carousel>
			
		</div>
		
		<div class="indiccol">
			<span class="title">{{list[signindex]?list[signindex].description:''}}</span>
			<div class="indicar">
				<div :class="signindex == index?'lamp_cur':'lamp'" v-for="(item,index) in list" 
				:key="index" @click="clickChange(index)">
					{{index + 1}}
				</div>
			</div>
		</div>
		
	</div>
	
</template>

<script>


export default {
 
  data: function() {
    return {
		signindex:0,
	    list:[],
		
    };
  },
  
  mounted(){
		this.getCarousel()
  },
  
  methods: {
		//数字指示器点击事件
		clickChange(index) {
			//参数index为图片索引
			this.signindex = index;
		    this.$refs.img.setActiveItem(index) //调动setActiveItem方法，动态切换图片
		},
		
		changetab(e){
		  	this.signindex = e
		},
		
		tonav(link) {
			window.open(link);
		},
		
		getCarousel(){
			this.$get(`web/webCarousel/list`).then(res=>{
				if(res.success){
					this.list = res.result	
				}
			})
			
		},
		
		
  },
  
  
  
};
</script>

<style scoped=" scoped" lang="scss">
	
.newsrotate{
	
	.rotatecon{	
		.el-image{
			cursor: pointer;
			width: 670px;
			height: 419px;
		}	
	}
	
	.indiccol{
		position: relative;
		z-index: 5;
		width:100%;
		height: 58px;
		margin-top: -58px;
		background-color: rgb(0,0,0,0.67);
		
		display: flex;
		align-items: center;
		justify-content: space-between;
		.title{
			margin-left: 10px;
			font-size: 18px;
			font-weight: 400;
			color: #FFFFFF;
			text-overflow: ellipsis;
			overflow: hidden;
			white-space: nowrap;
		}
		.indicar{
			display: flex;
			align-items: center;
			justify-content: center;
			margin-right: 20px;
			.lamp{
				cursor: pointer;
				background-color: #FFFFFF;
				width: 32px;
				height:32px;
				line-height: 32px;
				text-align: center;
				font-size: 18px;
				font-weight: 400;
				color: #C21B1F;
				margin-left: 10px;
			}
			.lamp_cur{
				cursor: pointer;
				background-color: #C21B1F;
				width: 50px;
				height: 50px;
				line-height:50px;
				text-align: center;
				font-size: 26px;
				font-weight: 400;
				color: #FFFFFF;
				margin-left: 10px;
			}
		}
	}
	
	
}

</style>
